var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary-steps-wrapper lg:mt-24 mt-6"},[_c('div',{staticClass:"summary-steps"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }